import { BEAUTY_CAMPAIGN_CODE, type PublicCampaign } from "@/shared/campaign/beautyCampaign";
import { trackCroEvent } from "@/shared/utils/croModals";
import { readStoredUtm } from "@/shared/utils/utm";

export type BeautyCampaignEvent =
    | "beauty_campaign_view"
    | "beauty_campaign_modal_view"
    | "beauty_campaign_modal_close"
    | "beauty_campaign_cta_click"
    | "beauty_campaign_signup_start"
    | "beauty_campaign_signup_complete"
    | "beauty_campaign_activation_success"
    | "beauty_campaign_activation_rejected"
    | "beauty_campaign_sold_out_view"
    | "beauty_campaign_upgrade_click"
    | "beauty_campaign_site_upsell_click";

export function trackBeautyCampaignEvent(
    eventName: BeautyCampaignEvent,
    campaign: PublicCampaign | null | undefined,
    extra: Record<string, string | number | undefined> = {},
) {
    const utm = readStoredUtm();
    trackCroEvent(eventName, {
        campaign_code: campaign?.campaign ?? BEAUTY_CAMPAIGN_CODE,
        preset: "BEAUTY",
        source: utm.utm_source,
        medium: utm.utm_medium,
        campaign: utm.utm_campaign,
        utm_source: utm.utm_source,
        utm_medium: utm.utm_medium,
        utm_campaign: utm.utm_campaign,
        utm_content: utm.utm_content,
        utm_term: utm.utm_term,
        remaining_slots: campaign?.remaining,
        plan: campaign?.plan ?? "start",
        ...extra,
    });
}
